import React from 'react';
import {withRouter, Link} from "react-router-dom";
import { connect } from 'react-redux';
import Sticky from 'react-stickynode';
import Api from './../api/api';
import DocumentMeta from 'react-document-meta';
import LoadingBar from 'react-top-loading-bar';

import filterArrowUp from './../assets/img/small-arrow-up.svg';
import filterArrowDown from './../assets/img/small-arrow-down.svg';


class Collections extends React.Component {

    state={
        sizeFilter:'',
        effectFilter:'',
        mobileSizeFilterOpen : false,
        mobileEffectFilterOpen : false,
        data:[],
        filterData:'',
        ref:React.createRef(null)
    }

    componentDidMount(){
        document.getElementById("fav-icon").href = process.env.PUBLIC_URL + "/CERAFINI_Collection.png";

        const {ref} = this.state;
        ref.current.continuousStart(10);

        Api.getCollection().then((response)=>{
            this.setState({data:this.mapResponseData(response.data.collections)});
            ref.current.complete();
        })
        Api.getFilterData().then((response)=>{
            this.setState({filterData: response.data})
        })
        Api.getMetaTags().then( ({data}) => {
            
            const {langTxt} = this.props;
            const {description, tags: keywords} = data.collections_tags["content_" + langTxt];

            this.setState({metatags: {
                title: 'Collections / Cerafini',
                description,
                meta: {
                  charset: 'utf-8',
                  name: {
                    keywords
                  }
                }
            }});
        });
    }

    mapResponseData = (response) =>{
        const {langTxt} =this.props;
        const collections=[];
        for(let i =0; i< response.length; i++){
            const collectionItem = {
                image:response[i].image_url,
                size:response[i].sizes.map((s)=> s["name_" + langTxt]),
                effect:response[i].effects.map((s)=> s["name_" + langTxt]),
                title:response[i]["name_"+langTxt],
                colorNumber:response[i].colors_count,
                id:response[i].id,
                colors:response[i].colors
            }

            collections.push(collectionItem)
        }
        return collections;
    }

    setSizes = () =>{ 
        const {sizeFilter,filterData} = this.state;
        const{langTxt}= this.props;
        return <>
            {filterData.sizes.map(size=>{
                const name =size["name_"+langTxt]
                const selected = (sizeFilter === name)? "underline" : '';
                return(
                    <p className={`cursor-pointer ${selected}`} onClick={()=>{this.setState({sizeFilter: (sizeFilter === name)? '' : name}); this.toggleFilter("mobileSizeFilterOpen");}}>{name}</p>
                )
            })}
        </>
    }    
    
    setEffects = () =>{ 
        const effects = ["metal", "wood", "marble", "fabric", "stone", "cement"];
        const {effectFilter,filterData} = this.state;
        const{langTxt}= this.props;
        return <>
            {filterData.effects.map(effect=>{
                const selected = (effectFilter === effect["name_"+langTxt])? "underline" : '';
                return(
                    <p className={`cursor-pointer ${selected}`} onClick={()=>{this.setState({effectFilter: (effectFilter === effect["name_"+langTxt])? '' : effect["name_"+langTxt]}); this.toggleFilter("mobileEffectFilterOpen");}}>{effect["name_"+langTxt]}</p>
                )
            })}
        </>
    }

    toggleFilter = (type) => {
        if (type === "mobileSizeFilterOpen"){
            this.setState({mobileSizeFilterOpen: !this.state.mobileSizeFilterOpen})
            return;
        }
        this.setState({mobileEffectFilterOpen: !this.state.mobileEffectFilterOpen})
    }

    renderDesktopFilter = () => {

        return(
            <div className="desktop-filter">
                <h3 className="desktop-filter-title">Filter</h3>
                <div className="desktop-filter-wrapper">
                    <h4>Size</h4>
                    {this.setSizes()}
                </div>
                <div className="desktop-filter-wrapper">
                    <h4>Effect</h4> 
                    {this.setEffects()}
                </div>
            </div>
        )
    }

    renderMobileFilter = () => {
        const {mobileSizeFilterOpen, mobileEffectFilterOpen,sizeFilter,effectFilter} = this.state;
        return (
            <div className="mobile-filter">
                <p className="mobile-filter-title">Filter</p>
                <div onClick={()=>this.toggleFilter("mobileSizeFilterOpen")} className="mobile-filter-wrapper">
                    <div className="filter-menu">
                        <p>Size</p>
                        {(mobileSizeFilterOpen)? <img src={filterArrowUp} alt="" />: <img src={filterArrowDown} alt="" />}
                    </div>
                    <div className={` filters-list ${(mobileSizeFilterOpen)? '' : 'd-none'}`}>
                        {this.setSizes()}
                    </div>
                    {(sizeFilter && !mobileSizeFilterOpen)? <p>{sizeFilter}</p>: ''}
                </div>
                <div onClick={()=>this.toggleFilter("mobileEffectFilterOpen")} className="mobile-filter-wrapper">
                    <div className="filter-menu">
                        <p>Effects</p>
                        {(mobileEffectFilterOpen)? <img src={filterArrowUp} alt="" />: <img src={filterArrowDown} alt="" />}
                    </div>
                    <div className={` filters-list ${(mobileEffectFilterOpen)? '' : 'd-none'}`}>
                        {this.setEffects()}
                    </div>
                    {(effectFilter && !mobileEffectFilterOpen)? <p>{effectFilter}</p>: ''}
                </div>
            </div>
        )
    }

    inArray = (arr, item)=> {
        return arr.indexOf(item) > -1;
    }

    filterCollections = () => {
        const {data, sizeFilter, effectFilter} =  this.state;
        return data.filter((item) => {
            if(sizeFilter && effectFilter){
                return this.inArray(item.size, sizeFilter) && this.inArray(item.effect, effectFilter);
            }else if(sizeFilter){
                return this.inArray(item.size, sizeFilter);
            }else if(effectFilter){
                return this.inArray(item.effect, effectFilter);
            }else{
                return item
            }
        })
            
        
    }

    renderFilteredCollections = () => {
        const data = this.filterCollections();
        const {langTxt,langUrl} = this.props;
        
        return <div className="collection-wrapper">
            {data.map((item,i)=>{
                return(
                    <div className="collection-item">
                        <p className="collection-item-number">{i+1}</p>
                        <Link to={langUrl+"/collections/" + item.id}>
                            <div className="collection-item-details">
                                <img src={item.image} alt="img"/>
                                <div className="collection-item-details-text">
                                    <p className="item-title">{item.title}</p>
                                    <div className="item-desc">
                                        <p className="item-size">{item.colorNumber} Colors</p>
                                        {(item.colors.filter((x)=>(x.type==="wall")).length > 0)?<p className="item-effect">Wall Section</p>:''}
                                    </div>
                                </div>
                            </div>
                        </Link>
                    </div>
                )
            })}
        </div>
    }

    renderRightSection = (data) => {
        const counter= data.length;
        return(
            <div className="right-section">
                <div className="collection-desc-wrapper">
                    <div className="collection-desc">
                        <p className="desc-title">Our Collections</p>
                        <p className="desc-text"  >Here you can browse our collection<span className="counter">{counter}</span>
                            <br/>The finest Italian stones and textures brought to you by Cerafini.</p>
                    </div>
                </div>
                {this.renderFilteredCollections(data)}
            </div>
        )
    }


    render (){
        const {langTxt, langUrl} = this.props;
        const {data,filterData,metatags} = this.state;
        const screenSize = window.innerWidth >= 1024;

       return (
        <DocumentMeta {...metatags}>
            <LoadingBar color='#000' height={4} ref={this.state.ref} />
            <div className="collections-page">
            {(filterData && data)?
                <>
                    <div className="collection-desc-mobile">
                        <p className="desc-title">Our Collections</p>
                            <p className="desc-text" >Here you can browse our collection<span className="counter">{data.length}</span>
                                <br/>The finest Italian stones and textures brought to you by Cerafini.</p>
                    </div>

                    <div className="filter">
                        {this.renderMobileFilter()}
                        {(screenSize)? 
                            <Sticky
                            bottomBoundary='.filter'
                            enabled={true} 
                            top={100}
                            key="sticky-filter"
                            >
                                {this.renderDesktopFilter()}
                            </Sticky>
                        :
                            <>
                                {this.renderDesktopFilter()}
                            </>
                        }
                        
                    </div>
                    {this.renderRightSection(data)}
                </>
                :<></>}
            </div>
            </DocumentMeta>
       );
    }
}


// what props do i need to get from the state for this component?
const mapStateToProps = (state) => {
    // get the props needed for this component from the state of the store.
    return {
        langTxt: (state.lang && state.lang.text) || 'en',
        langUrl: (state.lang && state.lang.url) || '',
    }
}

// what events will occur that will change the state in this component
const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter( connect(mapStateToProps, mapDispatchToProps)(Collections) );